import classNames from 'classnames';
import { t } from "../i18n";
import { jsxs as _jsxs } from "preact/compat/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/badge/).
 */
export const Badge = props => {
  const {
    className = '',
    children,
    size,
    variation,
    ...others
  } = props;
  const sizeClasses = {
    big: 'ds-c-badge--big'
  };
  const variationClass = variation && `ds-c-badge--${variation}`;
  const classes = classNames('ds-c-badge', variationClass, sizeClasses[size], className);
  return /*#__PURE__*/_jsxs("span", {
    className: classes,
    ...others,
    children: [variation && /*#__PURE__*/_jsxs("span", {
      className: "ds-u-visibility--screen-reader",
      children: [t(`badge.${variation}`), ": "]
    }), children]
  });
};
export default Badge;